import type { RouterConfig } from '@nuxt/schema'
import qs from 'qs'

// https://router.vuejs.org/api/interfaces/routeroptions.html
export default <RouterConfig>{
  parseQuery: qs.parse,
  stringifyQuery: qs.stringify,
  scrollBehavior(to, from, savedPosition) {
    const nuxtApp = useNuxtApp()

    if (to.hash) {
      let scrollDone = false

      nuxtApp.hooks.hookOnce('page:finish', () => {
        scrollDone = scrollToAnchor(to, scrollDone)
      })

      scrollDone = scrollToAnchor(to, scrollDone)

      return scrollDone
    } else if (savedPosition && from.path !== '/') {
      return savedPosition
    } else if (to.path !== from.path && from.path !== '/') {
      return new Promise(resolve => {
        nuxtApp.hooks.hookOnce('page:finish', () => {
          window.scrollTo({ left: 0, top: 0 })
          resolve()
        })
      })
    }

    return false
  },
}

function scrollToAnchor(to: any, scrollDone: boolean) {
  const heading = document.querySelector(to.hash) as any
  if (heading && !scrollDone) {
    const rect = heading.getBoundingClientRect()
    const distanceFromTop = rect.top + window.scrollY

    window.scrollTo({
      top: distanceFromTop,
      behavior: 'smooth',
    })

    return true
  }

  return false
}
